(function () {
    'use strict';

    var serviceId = 'locatorService';

    angular.module('app.common').factory(serviceId, locatorService);

    locatorService.$inject = ['$q', 'bolgeselDataService', '$window',
        'yandexGeocode', 'endeksaGeocode', 'guardSvc', '$translate', 'provinceListService'
    ];

    function locatorService($q, bolgeselDataService, $window,
        yandexGeocode, endeksaGeocode, guardSvc, $translate, provinceListService) {
        var service = {
            setPoint: setPoint,
            setPointCountry: setPointCountry,
            setPointProvince: setPointProvince,
            setPointCounty: setPointCounty,
            setPointNeighbourhood: setPointNeighbourhood,
            setPointSpanishNeighbourhood: setPointSpanishNeighbourhood,
            setPointBlock: setPointBlock,
            setPointParcel: setPointParcel
        };
        return service;

        function setPoint(address) {
            var deferred = $q.defer();

            if (address.indexOf('%252C') > -1) {
                address = address.replaceAllString('%252C', ',');
                address = address.replaceAllString('%253B35%252C', ';');
            }

            var lat;
            var lng;
            if (address.indexOf(';') > -1) {
                var latLon = address.split(';');
                lat = parseFloat(latLon[0].replace(",", "."));
                lng = parseFloat(latLon[1].replace(",", "."));
                bolgeselDataService.initialize(lat, lng, 0);
                deferred.resolve();
            } else if ($window.selectedLocation) {
                lat = +$window.selectedLocation.split(' ')[1];
                lng = +$window.selectedLocation.split(' ')[0];
                $window.selectedLocation = null;

                bolgeselDataService.initialize(lat, lng, 0);
                deferred.resolve();
            } else {
                address = address.replaceAllString('-', ' ');
                // if ($rootScope.country === 'turkiye')
                yandexGeocode.geocodeAddress(address)
                    .then(function (latlng) {
                        var lat = latlng.lat();
                        var lng = latlng.lng();
                        bolgeselDataService.initialize(lat, lng, 0);
                        deferred.resolve();
                    }, function () {
                        deferred.reject(false);
                    });
                // else
                //     googleGeocode.geocodeAddress(address)
                //         .then(function (latlng) {
                //             bolgeselDataService.initialize(latlng.lat, latlng.lng, 0);
                //             deferred.resolve();
                //         }, function () {
                //             deferred.reject(false);
                //         });
            }
            return deferred.promise;
        }
        function setPointCountry(country) {
            var deferred = $q.defer();
            if (country === 'world') {
                bolgeselDataService.initialize(0, 0, 10);
                deferred.resolve({ Country: 'world' });
            }
            else {
                endeksaGeocode.geocodeUrl(country)
                    .then((latlng) => {
                        const lat = latlng.lat();
                        const lng = latlng.lng();
                        bolgeselDataService.initialize(lat, lng, 9, null, latlng);
                        deferred.resolve({ Country: latlng.country });
                    })
                    .catch(() => {
                        deferred.reject(false);
                    });
            }
            return deferred.promise;
        }


        function setPointProvince(country, city) {
            var deferred = $q.defer();

            if ($window.selectedLocation) {
                const lat = +$window.selectedLocation.split(' ')[1];
                const lng = +$window.selectedLocation.split(' ')[0];
                $window.selectedLocation = null;
                let level = 1;
                let region = "";
                if (city.toLocaleLowerCase2('tr-tr').includes("reg-")) {
                    level = 11;
                    region = city.split("reg-")[1];
                    $window.regionId = region;
                }
                bolgeselDataService.initialize(lat, lng, level, region);
                deferred.resolve({ Country: country.toLocaleProperCase2(), City: city.toLocaleProperCase2('tr-tr') });
            } else {
                endeksaGeocode.geocodeUrl(country, city)
                    .then((latlng) => {
                        const lat = latlng.lat();
                        const lng = latlng.lng();

                        let level = 1;
                        let region = "";
                        if (city.toLocaleLowerCase2('tr-tr').includes("reg-")) {
                            level = 11;
                            region = city.split("reg-")[1];
                            $window.regionId = region;
                        }
                        bolgeselDataService.initialize(lat, lng, level, region, latlng);
                        deferred.resolve({ Country: latlng.country, City: latlng.city });
                    })
                    .catch(() => {
                        deferred.reject(false);
                    });
            }
            return deferred.promise;
        }


        function setPointCounty(country, city, county) {
            var deferred = $q.defer();
            if ($window.selectedLocation) {
                const lat = +$window.selectedLocation.split(' ')[1];
                const lng = +$window.selectedLocation.split(' ')[0];
                $window.selectedLocation = null;
                bolgeselDataService.initialize(lat, lng, 2).then(function (stats) {
                    // deferred.resolve({ City: stats.features[0].properties.City, County: stats.features[0].properties.County });
                });
                deferred.resolve({ City: city.toLocaleProperCase2('tr-tr'), County: county.toLocaleProperCase2('tr-tr') });
            } else {
                endeksaGeocode.geocodeUrl(country, city, county)
                    .then((latlng) => {
                        const lat = latlng.lat();
                        const lng = latlng.lng();
                        bolgeselDataService.initialize(lat, lng, 2, null, latlng);
                        deferred.resolve({ Country: latlng.country, City: latlng.city, County: latlng.county });
                    })
                    .catch(() => {
                        deferred.reject(false);
                    });
            }
            return deferred.promise;
        }


        function setPointNeighbourhood(country, city, county, district) {
            var deferred = $q.defer();
            // Spain uses the neighbourhood URL segment as the quarter layer.
            if (isSpain(country)) {
                setPointQuarter(country, city, county, district, deferred);
                return deferred.promise;
            }
            guardSvc.hasPackage([
                "real-estate-package",
                "location-package",
                "platinum-package",
                "premium-ee-package",
                "terminal-premium-package",
                "terminal-package",
                "premiumplus-package",
                "pro-ee-package",
                "flex-package",
                "gold-package",
                "terminal-flex-package",
                "terminal-pro-package"
            ], true)
                .then((result) => {
                    const level = result ? 6 : 3;
                    if ($window.selectedLocation) {
                        const lat = +$window.selectedLocation.split(' ')[1];
                        const lng = +$window.selectedLocation.split(' ')[0];
                        $window.selectedLocation = null;
                        bolgeselDataService.initialize(lat, lng, level);
                        deferred.resolve({ Country: country.toLocaleProperCase2(), City: city.toLocaleProperCase2('tr-tr'), County: county.toLocaleProperCase2('tr-tr'), District: district.toLocaleProperCase2('tr-tr') });

                    } else {
                        endeksaGeocode.geocodeUrl(country, city, county, district)
                            .then((latlng) => {
                                const lat = latlng.lat();
                                const lng = latlng.lng();
                                bolgeselDataService.initialize(lat, lng, level, null, latlng);
                                deferred.resolve({ Country: latlng.country, City: latlng.city, County: latlng.county, District: latlng.district, Population: latlng.population });

                            })
                            .catch(() => {
                                deferred.reject(false);
                            });
                    }
                });
            return deferred.promise;
        }

        // Resolves a Spain quarter URL segment and initializes the map with level 23.
        function setPointQuarter(country, city, county, quarterName, deferred) {
            getQuarterLocation(country, city, county, quarterName)
                .then(function (data) {
                    var latlng = data.latlng;
                    var quarter = data.quarter;
                    var quarterId = quarter.QuarterId || quarter.Id || quarter.DistrictId;
                    if (!quarterId) {
                        deferred.reject(false);
                        return;
                    }
                    bolgeselDataService.initialize(latlng.lat(), latlng.lng(), 23, null, {
                        countryId: latlng.countryId,
                        cityId: latlng.cityId,
                        countyId: latlng.countyId,
                        quarterId: quarterId,
                        quarter: quarter.QuarterName || quarter.Quarter || quarter.DistrictName || quarter.District,
                        country: latlng.country,
                        city: latlng.city,
                        county: latlng.county
                    });
                    deferred.resolve({ Country: latlng.country, City: latlng.city, County: latlng.county, Quarter: quarter.QuarterName || quarter.Quarter || quarter.DistrictName || quarter.District });
                })
                .catch(function () {
                    deferred.reject(false);
                });
        }

        function setPointSpanishNeighbourhood(country, city, county, quarterName, districtName) {
            var deferred = $q.defer();
            // Spain keeps the existing block route shape, but the last segment is a district name.
            getQuarterLocation(country, city, county, quarterName)
                .then(function (data) {
                    var quarterId = data.quarter.QuarterId || data.quarter.Id || data.quarter.DistrictId;
                    if (!quarterId) {
                        deferred.reject(false);
                        return;
                    }
                    return provinceListService.NeighbourhoodsOfQuarter(
                        data.latlng.countryId,
                        data.latlng.cityId,
                        data.latlng.countyId,
                        quarterId
                    ).then(function (response) {
                        var district = findByNormalized(response.List, districtName, ['DistrictName', 'District']);
                        var districtId = district && (district.DistrictId || district.Id);
                        if (!district) {
                            deferred.reject(false);
                            return;
                        }

                        bolgeselDataService.initialize(data.latlng.lat(), data.latlng.lng(), 3, null, {
                            countryId: data.latlng.countryId,
                            cityId: data.latlng.cityId,
                            countyId: data.latlng.countyId,
                            districtId: districtId,
                            quarterId: quarterId,
                            quarter: data.quarter.QuarterName || data.quarter.Quarter || data.quarter.DistrictName || data.quarter.District,
                            district: district.DistrictName || district.District,
                            country: data.latlng.country,
                            city: data.latlng.city,
                            county: data.latlng.county
                        });
                        deferred.resolve({
                            Country: data.latlng.country,
                            City: data.latlng.city,
                            County: data.latlng.county,
                            Quarter: data.quarter.QuarterName || data.quarter.Quarter || data.quarter.DistrictName || data.quarter.District,
                            District: district.DistrictName || district.District,
                            Population: district.Population
                        });
                    });
                })
                .catch(function () {
                    deferred.reject(false);
                });
            return deferred.promise;
        }

        // Finds the quarter id/name from county-level geo data before requesting its districts.
        function getQuarterLocation(country, city, county, quarterName) {
            return endeksaGeocode.geocodeUrl(country, city, county, null, null, null, quarterName)
                .then(function (latlng) {
                    return provinceListService.NeighbourhoodsOfCounty(latlng.countryId, latlng.cityId, latlng.countyId)
                        .then(function (response) {
                            var quarter = findByNormalized(response.List, quarterName, ['QuarterName', 'Quarter', 'DistrictName', 'District']);
                            if (!quarter) {
                                return $q.reject(false);
                            }
                            return {
                                latlng: latlng,
                                quarter: quarter
                            };
                        });
                });
        }

        // Compares URL-safe names with API names across known geo name fields.
        function findByNormalized(list, value, fields) {
            if (!list || !value) return null;
            var normalizedValue = normalizeAddress(value);
            for (var i = 0; i < list.length; i++) {
                for (var j = 0; j < fields.length; j++) {
                    if (list[i][fields[j]] && normalizeAddress(list[i][fields[j]]) === normalizedValue) {
                        return list[i];
                    }
                }
            }
            return null;
        }

        // Spain is the only country that uses the quarter layer in this flow.
        function isSpain(country) {
            return +country === 2 || normalizeAddress(country) === 'espana';
        }

        function setPointBlock(country, city, county, district, block) {
            var deferred = $q.defer();
            endeksaGeocode.geocodeUrl(country, city, county, district, block)
                .then(function (latlng) {
                    var lat = latlng.lat();
                    var lng = latlng.lng();
                    bolgeselDataService.initialize(lat, lng, 7, null, latlng);
                    deferred.resolve({ Country: latlng.country, City: latlng.city, County: latlng.county, District: latlng.district, BlockId: latlng.BlockId, BlockNo: block });
                }, function () {
                    deferred.reject(false);
                });
            return deferred.promise;
        }
        function setPointParcel(country, city, county, district, block, parcel) {
            var deferred = $q.defer();
            endeksaGeocode.geocodeUrl(country, city, county, district, block, parcel)
                .then(function (latlng) {
                    var lat = latlng.lat();
                    var lng = latlng.lng();
                    bolgeselDataService.initialize(lat, lng, 8, null, latlng);
                    deferred.resolve({ Country: latlng.country, City: latlng.city, County: latlng.county, District: latlng.district, BlockId: latlng.BlockId, ParcelId: latlng.ParcelId, BlockNo: block, ParcelNo: parcel });

                }, function () {
                    deferred.reject(false);
                });
            return deferred.promise;
        }
    }
})();
